import { computed } from 'vue';
import { calcularEdad } from '@/utils/dateUtils';

export function useEsMenorDeEdad(birthday) {
    const calculateAge = birthDate => {
        if (!birthDate) return null;
        return calcularEdad(birthDate);
    };

    const age = computed(() => calculateAge(birthday.value));
    const isMinor = computed(() => age.value !== null && age.value < 18);

    return {
        age,
        isMinor,
        calculateAge
    };
}
